<template>
  <main>
    <hero :heading="entry.title" :images="entry.heroImages" position="bottom" scrollToContent />
    <div id="scroll-content" class="c-section c-section--blue">
      <div class="o-wrapper o-wrapper--small">
        <div class="o-layout o-layout--large">
          <div class="o-layout__item u-4/7@desktop u-mb u-mb0@desktop" v-if="entry.introduction">
            <div class="c-rte o-box-off u-pt" v-html="entry.introduction"></div>
          </div>
          <div class="o-layout__item u-3/7@desktop" v-if="entry.map">
            <img :src="entry.map" alt="">
          </div>
        </div>
      </div>
    </div>
    <gallery v-if="images && images.length >= 1" :images="images" />
    <div class="c-section c-section--blue" v-if="entry.body">
      <div class="o-wrapper o-wrapper--small">
        <div class="c-rte o-box-off" v-html="entry.body"></div>
      </div>
    </div>
    <div class="c-section" v-if="entry && entry.relatedPosts">
      <div class="o-wrapper">
        <div class="c-section__header">
          <h3 class="c-section__heading u-600">Related News</h3>
          <router-link class="c-btn c-btn--quaternary" :to="{ name: 'news'}">View all news</router-link>
        </div>
        <ul class="o-layout o-layout--stretch o-layout--lined o-layout--large">
          <li class="o-layout__item u-1/3@tablet u-mb+ u-mb0@desktop" v-for="entry in entry.relatedPosts" :key="entry.id">
            <article-card :entry="entry" />
          </li>
        </ul>
      </div>
    </div>
  </main>
</template>

<script>
import axios from 'axios'
import Hero from '@/components/Hero.vue'
import Gallery from '@/components/Gallery.vue'
import ArticleCard from '@/components/ArticleCard.vue'

export default {
  name: 'Project',
  metaInfo () {
    return {
      title: this.title
    }
  },
  components: {
    Hero: Hero,
    Gallery: Gallery,
    ArticleCard: ArticleCard
  },
  data () {
    return {
      title: '',
      entry: null,
      images: []
    }
  },
  mounted () {
    this.getEntry(this.$route.params.slug)
  },
  // beforeRouteUpdate (to, from, next) {
  //   this.entry = null
  //   this.getEntry(to.params.slug)
  //   next()
  // },
  methods: {
    getEntry (slug, cb) {
      let vm = this
      axios
        .get('/api/projects/' + slug + '.json')
        .then(response => {
          vm.entry = response.data
          vm.images = response.data.images
          vm.title = this.entry.title
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Project.vue